<div class="toggle-item-row" [class.animate]="animate" [class.full-width]="fullWidth">
  @if (!expanded) {
    <div class="selected" (click)="toggle(); $event.stopPropagation()">
      @if (iconURL) {
        <app-svg-loader [url]="getIconUrl(iconURL)" height="13px"></app-svg-loader>
      }
      <span>{{ current?.label }}</span>
    </div>
  } @else {
    <div class="options">
      @if (iconURL) {
        <app-svg-loader [url]="getIconUrl(iconURL)" height="13px"></app-svg-loader>
      }
      @for (opt of options; track opt.value) {
        <div class="option" [class.active]="opt.value === value" (click)="select(opt.value)">
          <span>{{ opt.label }}</span>
        </div>
      }
    </div>
  }
</div>
